<div class="tab-header-container">
    <div class="title-container">
        <div class="icon-container">
            <app-icon [icon]="icon()" fontSize="18px"></app-icon>
        </div>
        <span class="header-text">{{headerTextKey() | translate}}</span>
        <ng-content select="[headerSuffix]"></ng-content>
    </div>
    <div class="separator"></div>
    @if (descriptionTextKey()) {
        <div class="description-container">
            <span class="description-text" [innerHTML]="descriptionTextKey() | translate"></span>
        </div>
    }
</div>
